import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const faqs = [
  {
    question: "What is multi agent AI decision-making Tool?",
    answer:
      "A multi agent AI platform that uses artificial intelligence to analyze complex problems, generate multi-perspective insights, and deliver data-backed recommendations for high-stakes decisions.",
  },
  {
    question: "What exactly is Omnix and how is it different from a standard AI chatbot?",
    answer:
      "Standard AI gives you one perspective. Omnix deploys multiple AI agent personas that debate and challenge each other, delivering synthesized intelligence from an expert panel, not a chatbot's guess.",
  },
  {
    question: "What kind of problems can Omnix solve?",
    answer:
      "Omnix multi agent AI platform for debates solves problems where one perspective creates blind spots, mergers and acquisitions due diligence, regulatory policy impact analysis, strategic pivots, and competitive positioning debates where conflicting expert opinions delay execution.",
  },
  {
    question: "How are the AI personas defined, and can we customize them?",
    answer:
      "Yes. Each persona embodies a distinct expert perspective—analytical, tactical, structural, or contrarian—and can be fully customized to reflect your industry's domain knowledge.",
  },
  {
    question: "What AI technology powers its AI decision making algorithm?",
    answer:
      "Omnix runs on GPT-4, Claude (Anthropic), and xAI models with direct API integration. Backend runs on Django and Python for debate orchestration with PostgreSQL storing persona logic and full debate archives.",
  },
  {
    question: "Is AI Decision-Making Software Constantly Updated with the Latest AI Technology?",
    answer:
      "Yes. Omnix is built on a flexible technical architecture that supports integration of the latest LLM advancements as AI technology evolves.",
  },
];

const Section7 = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="home-section-7">

      {/* FAQ */}
      <div className="faq-section">
        <div className="container">

          <h2 className="text-center">Frequently Asked Questions</h2>

          <div className="faq-list">
            {faqs.map((item, i) => (
              <div
                key={i}
                className={`faq-item ${active === i ? "active" : ""}`}
                onClick={() => setActive(active === i ? null : i)}
              >
                <div className="faq-question">
                  <span>{item.question}</span>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>

                <div className="faq-answer">
                  {item.answer}
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* CTA */}
      <div className="cta-section">
        <div className="container">
          <div className="cta-box text-center">

            <h2>Ready to Use #1 Multi-Agent AI Platform for Debates</h2>

            <p>
              Transform your decision-making process with AI-powered multi-persona debates.
              Get started today.
            </p>

            <button className="btn btn-light">Lets Get Started</button>

          </div>
        </div>
      </div>

    </section>
  );
};

export default Section7;